import { color as e } from "./atoms-v2953.js";
import { complex as m } from "./atoms-v2943.js";
import { dimensionValueTypes as p } from "./atoms-v21085.js";
import { testValueType as r } from "./atoms-v21104.js";
const t = [...p, e, m], s = (o) => t.find(r(o));
export {
  s as findValueType
};
